import { render } from "./NavbarSearch.vue?vue&type=template&id=fdfa5ecc&scoped=true&ts=true"
import script from "./NavbarSearch.vue?vue&type=script&lang=ts"
export * from "./NavbarSearch.vue?vue&type=script&lang=ts"

import "./NavbarSearch.vue?vue&type=style&index=0&id=fdfa5ecc&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fdfa5ecc"]])

export default __exports__